<template>
  <div>
    <Loading v-bind:show="showLoading">
      <PageTitle title="Situação Acadêmica" />
      <div v-show="!showLoading">
        <md-toolbar id="md-toolbar-page" md-elevation="0" class="md-dense" style="background-color: inherit">
          <h3 class="md-title" style="flex: 1"></h3>
          <md-button v-if="showButtonInclude" class="md-text-and-icon md-outlined md-primary md-dense" @click="modalInclusao = true;">
            <md-icon>playlist_add</md-icon>Incluir
          </md-button>
        </md-toolbar>
        <div class="md-layout-item md-size-100" v-if="dadosAba">

            <GridSituacaoAcademica v-bind:Data="dadosAba.situacaoAcademica"
                v-bind:Header="header"
                Name="SituacaoAcademica"
                Title="Total"
                OrderBy="dataSituacao"
                v-bind:HeaderDetalhes="null"
                v-bind:DetalhesCombo1="dadosAba.periodo"
                v-bind:DetalhesCombo2="dadosAba.situacao"
                v-bind:DetalhesCombo3="null" v-if="$featureToggle && $featureToggle.INTEGRA_SITUACAOACADEMICA_GRID"
                @carregaAba="carregaAba()"
                @changeShowButtonInclude="changeShowButtonInclude" />
        </div>
      </div>
    </Loading>

    <!--MODAL DE INCLUSAO DE SITUACAO ACADEMICA-->
    <md-dialog :md-active.sync="modalInclusao" v-if="dadosAba">
      <form novalidate @submit.prevent="validate">
        <md-card>

          <md-card-header>
            <div class="md-title">Incluir Situação Acadêmica</div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100">
                <md-field>
                  <label>Aluno:</label>
                  <md-input :value="aluno.codigoAluno + '' + aluno.codigoEspecialidade + ' - ' + aluno.nomeAluno" disabled></md-input>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field :class="getValidationClass('periodo')">
                  <label for="periodo">Período da Situação</label>
                  <md-select name="periodo" id="periodo" v-model="form.periodo" md-dense :disabled="sending" v-if="dadosAba.rangePeriodos">
                    <md-option v-for="item in dadosAba.rangePeriodos" :key="item.codigoPeriodo" :value="item.codigoPeriodo  ">{{item.ano}}/{{item.semestre}}</md-option>
                  </md-select>
                  <span class="md-error">É necessário informar o Período da Situação.</span>
                </md-field>
              </div>

              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field :class="getValidationClass('situacao')">
                  <label for="situacao">Situação</label>
                  <md-select ref="cbSituacao" name="situacao" id="situacao" v-model="form.situacao" md-dense :disabled="sending">
                    <md-option v-for="item in dadosAba.listaSituacoes" :key="item.cod" :value="item.cod">{{item.desc}}</md-option>
                  </md-select>
                  <span class="md-error">É necessário informar a Situação.</span>
                </md-field>
              </div>

              <div class="md-layout-item md-size-33 md-small-size-100">


                <md-datepicker v-model="form.data" md-immediately>
                  <label>Data de inclusão</label>
                </md-datepicker>
                <!--<span class="md-error" v-if="!$v.form.data.required">É necessário informar a Data de Inclusão.</span>-->
              </div>

              <div class="md-layout-item md-size-100">
                <md-field :class="getValidationClass('observacao')">
                  <label>Observações</label>
                  <md-textarea v-model="form.observacao" :disabled="sending"></md-textarea>
                  <span class="md-error" v-if="!$v.form.observacao.required">É necessário informar as Observações.</span>
                  <span class="md-error" v-else-if="!$v.form.observacao.maxlength">Tamanho máximo das observações é de 2000 caracteres.</span>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-progress-bar md-mode="indeterminate" v-if="sending" />

          <md-card-actions>
            <!--<md-button class="md-text-and-icon md-raised md-warning" @click="modalInclusao = false">
              <md-icon>report_problem</md-icon>Autorizar Matrícula
            </md-button>-->
            <md-button class="md-text-and-icon md-raised md-primary" type="submit">
              <md-icon>check</md-icon>Salvar
            </md-button>
            <md-button class="md-text-and-icon md-raised md-error" @click="cancel">
              <md-icon>cancel</md-icon>Cancelar
            </md-button>
          </md-card-actions>
        </md-card>
      </form>
    </md-dialog>
  </div>
</template>
<script>
    import GridSituacaoAcademica from '@/components/GridSituacaoAcademica';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import SituacaoAcademica from '@/services/SituacaoAcademicaService.js';

  import { validationMixin } from 'vuelidate'
  import {
    required,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
        aluno: null,
        showLoading: false,
        showButtonInclude: true,
        modalInclusao: false,
        sending: false,
        form: {
          periodo: null,
          situacao: null,
          data: null,
          observacao: null
        },
        validacoesRegra: "",
        header: [
          {
            Titulo: "Período",
            Field: "periodo",
            Width: "100px",
            Tipo: "texto"
          },
          {
            Titulo: "Data",
            Field: "dataSituacao",
            Width: "80px",
            Tipo: "date"
          },
          {
            Titulo: "Situação",
            Field: "situacaoDescricao",
            Width: "200px",
            Tipo: "texto"
          },
          {
            Titulo: "Início Contrato",
            Field: "inicioContrato",
            Width: "100px",
            Tipo: "date"
          },
          {
            Titulo: "Fim Contrato",
            Field: "terminoContrato",
            Width: "100px",
            Tipo: "date"
          },
          {
            Titulo: "Observação",
            Field: "observacao",
            Width: "200px",
            Tipo: "texto"
            },
            {
                Titulo: "Remover",
                Field: "remover",
                Width: "20px",
                Tipo: "remove-button"
            }
        ],

        dadosAba: null
      }
    },

    mixins: [validationMixin],

    validations: {
      form: {
        periodo: {
          required
        },
        situacao: {
          required
        },
        data: {
          required
        },
        observacao: {
          required,
          maxLength: maxLength(2000)
        }
      }
    },

    components: {
      GridSituacaoAcademica,
      Loading,
      PageTitle
    },
    created() {
      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
          //Verifica se os dados da Aba ja esta carregado
          if (a.SituacaoAcademica) {
            this.dadosAba = a.SituacaoAcademica;
          }
        }
        else
          this.$router.push('home');
      }

      this.situacaoAcademicaService = new SituacaoAcademica(this);

      if (this.$featureToggle.INTEGRA_SITUACAOACADEMICA_GRID) {
        //Verifica se a aba não está carregada
        if (!this.dadosAba) {
          this.carregaAba();
        }
      }
      else {
        this.$modal.alert(this.$msgFeatureToggle);
      }
    },

    beforeDestroy() {
      let aluno = JSON.parse(sessionStorage.Aluno);

      //Armazena os dados da aba pra nao precisar carregar novamente
      aluno.SituacaoAcademica = this.dadosAba;
      sessionStorage.setItem("Aluno", JSON.stringify(aluno));
    },

    methods: {
        changeShowButtonInclude(loading) {
            console.log('change show ' + loading);
            this.showButtonInclude = loading;
        },
        carregaAba() {
        //Popula os dados da aba
        this.showLoading = true;
        this.situacaoAcademicaService.ObterSituacaoAcademica({
          CodigoAluno: this.aluno.codigoAluno,
          CodigoEspecialidade: this.aluno.codigoEspecialidade,
          CodigoEmpresa: this.aluno.codigoEmpresa
        }).then(
          data => {
            if (data.ok) {
              this.dadosAba = data.dados;
            }
            else {
              this.$modal.info(data.Mensagem);
            }
          },
          error => {
            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
          }).finally(() => {
              this.showLoading = false;
          });
      },

      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },

      clearForm() {
        this.$v.$reset()
        this.form.periodo = null
        this.form.situacao = null
        this.form.data = null
        this.form.observacao = null
      },

      save() {
        this.sending = true
        this.situacaoAcademicaService.CadastrarSituacaoAcademica({
          codigoAluno: this.aluno.codigoAluno,
          codigoEspecialidade: this.aluno.codigoEspecialidade,
          codigoPeriodo: this.form.periodo,
          dataSituacao: this.form.data,
          codigoSituacao: this.form.situacao,
          textoSituacao: this.form.observacao
        }
        ).then(
          data => {
            if (data.ok) {
              this.$notify.showDuration('center', 4000, data.mensagem);
              this.modalInclusao = false;
              this.clearForm();
            }
            else {
              this.$notify.showInfinite('center', data.Mensagem);
            }
          },
          error => {
            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
          }).finally(() => {
            this.sending = false;
            this.carregaAba();
          });

      },

      cancel() {
        this.modalInclusao = false;
        this.clearForm();
      },

      validate() {
        this.$v.$touch()

        if (!this.$v.$invalid) {

          //Valida se a data condiz com o período
          //if (this.form.periodo) {
          //  let ano = this.form.periodo.split('/')[0];
          //  let semestre = this.form.periodo.split('/')[1];
          //  let dtInicio1 = new Date(ano, 1, 1);
          //  let dtInicio2 = new Date(ano, 7, 1);

          //  if ((semestre == 1 && !(this.form.data >= dtInicio1 && this.form.data < dtInicio2))
          //    || (semestre == 2 && !(this.form.data >= dtInicio2 && this.form.data < new Date(ano + 1, 1, 1)))) {
          //    this.validacoesRegra = "A 'Data de inclusão' informada não condiz com o 'Período' selecionado.";
          //    return;
          //  }
          //}

          //Filtra as situações do período
          let situacoesPeriodo = this.dadosAba.situacaoAcademica.filter((item) => {
            return item.periodo == this.form.periodo;
          });

          //Situação selecionada
          let situacaoSelecionada = this.$refs.cbSituacao.MdSelect;
          //  this.dadosAba.listaSituacoes.filter((item) => {
          //  return item.cod == this.form.situacao;
          //})[0];


          //Ordena as situações por data
          //let situacoesOrdenadas = situacoesPeriodo.sort(function (a, b) {
          //  var keyA = new Date(a.dataSituacao),
          //    keyB = new Date(b.dataSituacao);
          //  // Compare the 2 dates
          //  if (keyA < keyB) return -1;
          //  if (keyA > keyB) return 1;

          //  return 0;
          //});

          //Pega a última situação do período
          //let ultimaSituacao = situacoesOrdenadas[situacoesOrdenadas.length - 1];
          var validacoesRegra = "";
          var result = null;

          switch (this.form.situacao) {

            //Ao retornar a inclusão de situação acadêmica "Cursando", validar se existe a situação anterior "PMA" para o mesmo período e com data anterior a data da nova situação;
            case 'C':
              result = situacoesPeriodo.filter((item) => {
                return item.situacao == 'P' && new Date(item.dataSituacao) < this.form.data;
              });

              if (!result || result.length == 0) {
                validacoesRegra = "Não é possível incluir uma situação 'Cursando' sem existir uma de 'Período de Matrícula' com data anterior para o mesmo período.";
              }

              break;

            //Ao retornar a inclusão de situação acadêmica "PMA", validar se existe a situação anterior "Cursando" ou 'Trancada" com período e data anterior a data da nova situação;
            case 'P':
              result = this.dadosAba.situacaoAcademica.filter((item) => {
                return (item.situacao == 'C' || item.situacao == 'T') && item.periodo < this.form.periodo && new Date(item.dataSituacao) < this.form.data;
              });

              if (!result || result.length == 0) {
                validacoesRegra = "Não é possível incluir uma situação 'Período de Matrícula' sem existir uma de 'Cursando' ou 'Trancada' com data anterior.";
              }

              break;

            //Ao retornar a inclusão de situação acadêmica "E - Matrícula Cancelada, F - Formado, R - Transferido, T - Matrícula Trancada, X - Expulso", validar se existe a situação anterior "PMA" ou "Cursando" com data anterior a data da nova situação;
            case 'E':
            case 'F':
            case 'R':
            case 'T':
            case 'X':
              result = this.dadosAba.situacaoAcademica.filter((item) => {
                return (item.situacao == 'P' || item.situacao == 'C') && new Date(item.dataSituacao) < this.form.data;
              });

              if (!result || result.length == 0) {
                validacoesRegra = "Não é possível incluir uma situação '" + situacaoSelecionada.label + "' sem existir uma de 'Período de Matrícula', 'Cursando' ou 'Trancada' com data anterior.";
              }

              break;

            //Ao retornar a inclusão de situação acadêmica "D - Desistente", validar se existe a situação anterior "PMA", "Cursando" ou "Trancada" com data anterior a data da nova situação;
            case 'D':
              result = this.dadosAba.situacaoAcademica.filter((item) => {
                return (item.situacao == 'P' || item.situacao == 'C' || item.situacao == 'T') && new Date(item.dataSituacao) < this.form.data;
              });

              if (!result || result.length == 0) {
                validacoesRegra = "Não é possível incluir uma situação '" + situacaoSelecionada.desc + "' sem existir uma de 'Cursando' ou 'Trancada' com data anterior.";
              }

              break;
          }

          if (validacoesRegra) {
            this.$notify.showInfinite('center', validacoesRegra);
            return;
          }

          this.save();
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-field {
    max-width: 100%;
    font-weight: bold;
  }

  .md-dialog {
    width: 80%;
    left: 10%;
  }

  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }

  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
</style>
